import React, {useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    TabContent,
    TabPane,
    NavLink,
    NavItem,
    Nav,
  } from "reactstrap"

import classnames from "classnames"
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingModal from "../../components/Common/LoadingModal"
import AdmAccountManagementSearch from './AdmAccountManagementSearch';
import AdmCreateAccount from './AdmCreateAccount';
import '../../components/Common/Common.css';

import {
  setAdmAccountManagementSearchSuccess,
  setAdmAccountManagementSearchResult,
  setAdmAccountManagementSearchError,
  setAdmAccountManagementLoading as onSetAdmAccountManagementLoading,
} from "../../store/actions";

const AdmAccountManagement = props => {
  const dispatch = useDispatch();
  const { loading, error, success, result } = useSelector(state => ({
    loading: state.AdmAccountManagement.loading,
    success: state.AdmAccountManagement.success,
    error: state.AdmAccountManagement.error,
    result: state.AdmAccountManagement.result,
  }));

  const [activeTab, setActiveTab] = useState("Search")
  function toggleActiveTab(tab) {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const setAdmAccountManagementLoading = () => {
    dispatch(onSetAdmAccountManagementLoading(!loading))
  }

  const errMsg = [
    "Enter username!"
    , "Input Start date!"
    , "Input End date!"
    , "Input new member password!"
    , "Your password is not strong enough. Please select a new password containing at least one letter, one number, and one special character (! & $ # etc)."
    , "Input confirm new member password!"
    , "New member password and Confirm new member password must be the same value!"
    , "System Error. Contact your system administrator!"
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Nav tabs className="col-md-6 nav-tabs-custom nav-justified">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: activeTab === "Search",
                })}
                onClick={() => {
                  toggleActiveTab("Search")
                }}
              >
                <span>Search</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: activeTab === "Create",
                })}
                onClick={() => {
                  toggleActiveTab("Create")
                }}
              >
                <span>Create new account</span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={activeTab}
            className="text-muted"
          >
            <TabPane tabId="Search">
              <AdmAccountManagementSearch/>
            </TabPane>
            <TabPane tabId="Create">
              <AdmCreateAccount toggleActiveTab={toggleActiveTab}/>
            </TabPane>
          </TabContent>

          {
            loading ?
            <LoadingModal loading={loading} setLoading={setAdmAccountManagementLoading}></LoadingModal>
            : null
          }

          {
            success ? 
            <SweetAlert
              title={success}
              timeout={2000}
              showCloseButton={false}
              showConfirm={false}
              success
              onConfirm={() => {
                dispatch(setAdmAccountManagementSearchSuccess(""));
              }}
            ></SweetAlert>
            : null
          }

          {
            result !== -1 ? (
            <SweetAlert
              warning
              title={errMsg[result]}
              onConfirm={() => {
                dispatch(setAdmAccountManagementSearchResult(-1));
              }}
            >
            </SweetAlert>
            ) : null
          }

          {
            error ?
            <SweetAlert
              warning
              title={error}
              onConfirm={() => {
                dispatch(setAdmAccountManagementSearchError(""));
              }}
            >
            </SweetAlert>
            : null
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default AdmAccountManagement;